<template>
  <div id="" class="mainDiv">
    <div class="head clearfix">
      <el-button
        type="primary"
        size="small"
        @click="goBack"
        class="head-li"
        style="float: left"
        >返回</el-button
      >
      <h3 class="head-li" style="text-align: center">批阅作业</h3>
    </div>
    <el-form ref="form" :model="form" label-width="140px">
      <div class="student-info">
        <div>学生姓名：{{ this.form.uname }}</div>
        <div>手机号：{{ this.form.phone }}</div>
        <div>准考证号：{{ this.form.admissionCard }}</div>
        <div>提交时间：{{ this.form.submitDate }}</div>
      </div>

      <el-form-item prop="name" label="作业主题：">
        <p>{{ this.form.homeworkTopic }}</p>
      </el-form-item>
      <!-- <el-form-item label="作业："></el-form-item> -->
      <el-form-item
        label="作业："
        prop="homeworkContent"
        style="position: relative"
      >
        <quill-editor
          ref="quillEditor"
          v-model="form.homeworkContent"
          :options="options"
          style="width: calc(100% - 40px)"
          oninput="if(value.length > 10000) value=value.slice(0, 20)"
          disabled
        >
          <div id="toolbar" slot="toolbar" style="height: 0; padding: 0"></div>
        </quill-editor>
      </el-form-item>
      <el-form-item
        label="答题结果："
        prop="answerContent"
        style="position: relative"
      >
        <quill-editor
          ref="quillEditor2"
          v-model="form.answerContent"
          :options="options2"
          style="width: calc(100% - 40px)"
          disabled
        >
          <div id="toolbar2" slot="toolbar" style="height: 0; padding: 0"></div>
        </quill-editor>
      </el-form-item>
      <el-form-item
        label="答案解析："
        prop="homeworkAnswer"
        style="position: relative"
      >
        <quill-editor
          ref="quillEditor3"
          v-model="form.homeworkAnswer"
          :options="options3"
          style="width: calc(100% - 40px)"
          oninput="if(value.length > 10000) value=value.slice(0, 20)"
          disabled
        >
          <div id="toolbar3" slot="toolbar" style="height: 0; padding: 0"></div>
        </quill-editor>
      </el-form-item>
      <el-form-item label="答题附件：" style="border-bottom: 1px solid #cccccc">
        <a
          :href="this.form.hreftxt"
          class="download"
          v-if="this.form.answerAccessory != null"
          >{{ this.form.answerAccessory }}</a
        >
      </el-form-item>
      <el-form-item v-if="false" label="查重率：">
        <span class="download">{{ this.form.repeatChance }}</span>
      </el-form-item>
      <el-form-item prop="markingScore" label="评分：">
        <el-input
          v-model="form.markingScore"
          :min="0"
          :max="100"
          @input.native="onInput0_100"
          clearable
          style="width: 400px"
          placeholder="1-100分"
        ></el-input>
      </el-form-item>
      <el-form-item prop="markingComment" label="评语：">
        <el-input
          type="textarea"
          rows="10"
          v-model="form.markingComment"
          style="height: 200px"
        ></el-input>
      </el-form-item>
      <!--    <el-form-item v-if="form.markingAccessory" prop="name" label="附件大小设定：">-->
      <!--      <el-input v-model="form.markingAccessorySize" placeholder="1-100M" style="width: 400px;"></el-input>-->
      <!--    </el-form-item>-->
      <el-form-item label="附件上传：">
        <el-upload
          v-if="file === ''"
          class="upload-demo"
          :action="url + '/zkfz/zkolHomework/saveHomeworkMarking'"
          ref="upload"
          :auto-upload="false"
          accept=".zip,.doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.rar,.zip,.7z"
          :on-change="handleChange"
          :on-success="handleAvatarSuccess"
          :limit="1"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传word、excel、PDF、图片、压缩包类型文件，且不超过一个
          </div>
        </el-upload>
        <el-upload
          v-else
          class="upload-demo"
          :action="url + '/zkfz/zkolHomework/saveHomeworkMarking'"
          ref="upload"
          :auto-upload="false"
          accept=".zip,.doc,.docx,.xls,.xlsx,.pdf,.jpg,.jpeg,.png,.rar,.zip,.7z"
          :on-change="handleChange"
          :limit="2"
          :file-list="[file]"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传word、excel、PDF、图片、压缩包类型文件，且不超过一个
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label-width="0px" style="padding: 20px 0">
        <el-button
          type="primary"
          @click="onSubmit(2)"
          style="margin: 0 20px; width: 98px"
          >确认批阅</el-button
        >
        <el-button
          type="primary"
          @click="showSendback = 1"
          style="margin: 0 20px; width: 98px"
          >退回作业</el-button
        >
        <el-button
          type="primary"
          @click="goBack"
          style="margin: 0 20px; width: 98px"
          >返回</el-button
        >
      </el-form-item>
    </el-form>
    <section v-if="showSendback" class="send-back">
      <h3>退回原因</h3>
      <textarea
        class="send-back-textarea"
        v-model="checkComment"
        name="checkComment"
        id="checkComment"
        cols="60"
        rows="15"
      ></textarea>
      <div class="clearfix" style="margin-top: 10px">
        <el-button
          type="primary"
          @click="showSendback = 0"
          style="margin: 0; width: 98px; float: right"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="onSubmit(3)"
          style="margin: 0 20px; width: 98px; float: right"
          >确认退回</el-button
        >
      </div>
    </section>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/homework/homework'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
export default {
  name: 'homeworkEdit',
  components: {
    quillEditor,
  },
  data() {
    return {
      form: {
        name: '',
        content: '',
        ground: '',
        uploadFileList: [],
        submitDate: [new Date(2021, 2, 1, 0, 0), new Date(2021, 2, 1, 0, 0)],
        attachment: 0,
        attachmentSize: '',
        isCheckRepetition: 0,
        staus: 0,
        MarkingScore: '',
        MarkingComment: '',
      },
      checkComment: '',
      options: {
        placeholder: '请输入内容',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
      options2: {
        placeholder:
          '富文本内容大小不能超过20000字节，图片合集请用压缩包上传附件！',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar2',
        },
      },
      options3: {
        placeholder:
          '富文本内容大小不能超过20000字节，图片合集请用压缩包上传附件！',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar3',
        },
      },
      file: '',
      loading: false,
      editBtnStyle: '0',
      showSendback: 0,
      isDisabled: true,
    }
  },
  methods: {
    //评分
    onInput0_100(e) {
      this.$message.closeAll()
      // 验证是否是纯数字
      let isNumber = /^\d*$/.test(e.target.value)
      // 过滤非数字
      e.target.value = e.target.value.replace(/\D/g, '')
      if (!isNumber || e.target.value < 0 || e.target.value > 100) {
        this.$message.warning('只能输入[0,100]区间的整数')
      }
      e.target.value =
        (e.target.value >= 0 &&
          e.target.value <= 100 &&
          e.target.value.match(/^\d*/g)[0]) ||
        null
    },
    getdata() {
      let reqdata = {
        answerId: this.$route.query.id,
      }
      api.getHomeworkAnswerInfo(reqdata).then((res) => {
        console.log(res.data.data)
        if (res.data.data != null) {
          this.form = res.data.data
        }
        console.log(this.form)

        // this.form.hreftxt='http://localhost:8081/zkfz/zkolHomework/getFile?id='+this.$route.query.id;
        this.form.hreftxt =
          this.url + '/zkfz/zkolHomework/getFile?id=' + this.$route.query.id
        console.log(res.data.data.hid)

        // let fdata={
        //     id : res.data.data.hid
        // }
        // console.log(this.$route.query)
        // console.log(this.$route.query.id)
        // api.getFile(fdata).then(({ data }) => {
        //     // console.log(data)
        //     let files=new File([data], this.form.answerAccessory, {type: data.type});
        //     console.log(files)
        //     this.file=files
        // })
      })
    },
    goBack() {
      window.history.go(-1)
    },
    handleChange(file, fileList) {
      this.file = file.raw
    },
    onSubmit(type) {
      console.log(this.markingScore)
      console.log(this.checkComment.length)
      let flag = true
      let size = true
      if (this.file) {
        flag = this.beforeUpload(this.file)
        size = this.fileSize(this.file)
      }
      if (!size) {
        this.$message({
          type: 'error',
          message: `上传文件大小不得小于1KB,不得大于30MB!`,
        })
        return
      } else if (!flag) {
        this.$message({
          type: 'error',
          message: `只能上传word、excel、PDF、图片、压缩包类型文件，且不超过一个`,
        })
        return
      }
      if (type == 3 && (this.checkComment == '' || this.checkComment == null)) {
        this.$message({ type: 'warning', message: `退回原因必填！` })
        return
      } else if (type == 3 && this.checkComment.length > 100) {
        this.$message({ type: 'warning', message: `不能超过100字！` })
        return
      } else if (
        type == 2 &&
        (this.form.markingScore == '' || this.form.markingScore == null)
      ) {
        this.$message({ type: 'warning', message: `评分必填！` })
        return
      } else if (
        type == 2 &&
        (this.form.markingComment == '' || this.form.markingComment == null)
      ) {
        this.$message({ type: 'warning', message: `评语必填！` })
        return
      } else if (type == 2 && this.form.markingComment.length > 100) {
        this.$message({ type: 'warning', message: `不能超过100字！` })
        return
      }
      let reqdata = {
        answerId: this.$route.query.id,
        markingScore: this.form.markingScore,
        markingComment: this.form.markingComment,
        checkComment: this.checkComment,
        submitType: type,
        createUid: localStorage.getItem('uid') ,
      }
      let filedata = this.file
      console.log(filedata)
      if (this.isDisabled) {
        this.isDisabled = false //锁定
        api.saveHomeworkMarking(reqdata, filedata).then((res) => {
          console.log(res.data)
          if (type === 3) {
            if (res.data.code === 100000) {
              this.$message({ type: 'success', message: `已退回！` })
              window.history.go(-1)
            } else {
              this.$message({ type: 'warning', message: `退回失败！` })
            }
          } else {
            if (res.data.code === 100000) {
              this.$message({ type: 'success', message: `批阅成功！` })
              window.history.go(-1)
            } else {
              this.$message({ type: 'warning', message: `批阅失败！` })
            }
          }
          this.isDisabled = true //解除锁定
        })
      } else {
        this.$message({ type: 'error', message: '请勿重复操作' })
      }
    },
    bind() {
      let reqdata = {
        id: this.$route.query.id,
      }
      api.getFile(reqdata).then((res) => {
        // console.log(res.data.data);
        // this.form=res.data.data;
        // console.log(this.form);
        // this.form.submitDate=moment(this.form.submitDate).format("YYYY-MM-DD HH:mm:ss")
        // this.form.hreftxt='http://localhost:8081/zkfz/getFile?id='+this.$route.query.id+"'";
      })
    },
    beforeUpload(file) {
      console.log(file.type)
      if (
        file.name.substring(file.name.lastIndexOf('.')) == '.rar' ||
        file.name.substring(file.name.lastIndexOf('.')) == '.7z'
      ) {
        return true
      }
      const allowList = [
        '.pdf',
        'application/pdf',
        '.png',
        'image/png',
        '.jpg',
        'image/jpg',
        'image/jpeg',
        '.xlsx',
        '.xls',
        'application/vnd.ms-excel',
        'application/excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.doc',
        'application/doc',
        'application/msword',
        '.zip',
        'application/zip',
        '.rar',
        'application/rar',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.docx',
      ]
      if (allowList.includes(file.type)) {
        console.log('----')
        return true
      } else {
        return false
      }
    },
    fileSize(file) {
      const isLt =
        file.size / 1024 / 1 >= 1 && file.size / 1024 / 1024 / 30 <= 1
      if (!isLt) {
        return false
      }
      return true
    },
    handleAvatarSuccess() {},
  },
  mounted() {
    this.getdata()
  },
  created() {
    const deitStyle = this.$route.query.edit_style
    this.editBtnStyle = deitStyle
    //判断是新增页面还是编辑页面
    if (deitStyle != '0') {
      // this.getParams()
      // this.getFile()
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
}
.clearfix:after {
  content: '';
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
/deep/.ql-editor {
  min-height: 300px;
}
.student-info {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #cccccc;
  padding: 15px;
}
.download {
  color: #0099ff;
  text-decoration: none;
}
.send-back {
  position: fixed;
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30%;
  border: 1px solid black;
  background-color: white;
  padding: 10px;
}
.send-back-textarea {
  width: 100%;
  padding: 10px;
}
</style>
